import { render } from "./reset-link-failed.vue?vue&type=template&id=b9340d0c&ts=true"
import script from "./reset-link-failed.vue?vue&type=script&lang=ts"
export * from "./reset-link-failed.vue?vue&type=script&lang=ts"

import "./reset-link-failed.vue?vue&type=style&index=0&id=b9340d0c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__